<template>
  <div>
    <!-- Desktop -->
    <div class="white text-body-2 black--text mt-3 mb-3 pt-6 pb-6 pl-8 pr-8 d-none d-md-flex align-center rounded-lg">
      <div class="info--usuario font-weight-bold text-truncate">
        {{ user.username }}
      </div>
      <div class="info--rol">
        <v-chip :color="rolColor" dark small>{{ user.rol }}</v-chip>
      </div>
      <div class="info--estatus">
        <v-chip :color="user.estatus ? 'success' : 'error'" dark small>
          {{ user.estatus ? 'Activo' : 'Inactivo' }}
        </v-chip>
      </div>
      <div class="info--fecha">
        {{ getShortDate(user.created_at) }}
      </div>
      <div class="info--action d-flex justify-center">
        <v-btn v-if="showEdit" class="mr-2" depressed outlined color="primary" small @click="$emit('edit', user)">
          <v-icon small left>mdi-pencil</v-icon> EDITAR
        </v-btn>
        <v-btn v-if="showEdit" depressed outlined color="primary" small @click="$emit('changePassword', user)">
          <v-icon small left>mdi-lock-reset</v-icon>
        </v-btn>
        <v-btn v-if="showDelete" class="ml-2" depressed outlined color="error" small @click="$emit('delete', user)">
          <v-icon small left>mdi-delete</v-icon>
        </v-btn>
      </div>
    </div>

    <!-- Mobile -->
    <div class="white text-body-2 black--text mt-3 mb-3 pa-4 d-flex d-md-none flex-column rounded-lg">
      <div class="d-flex justify-space-between align-center mb-2">
        <span class="font-weight-bold">{{ user.username }}</span>
        <v-chip :color="user.estatus ? 'success' : 'error'" dark x-small>
          {{ user.estatus ? 'Activo' : 'Inactivo' }}
        </v-chip>
      </div>
      <div class="d-flex justify-space-between align-center mb-2">
        <span class="grey--text">Rol:</span>
        <v-chip :color="rolColor" dark x-small>{{ user.rol }}</v-chip>
      </div>
      <div class="d-flex justify-space-between align-center mb-3">
        <span class="grey--text">Creado:</span>
        <span>{{ getShortDate(user.created_at) }}</span>
      </div>
      <div class="d-flex justify-center" v-if="showEdit">
        <v-btn class="mr-2" depressed outlined color="primary" x-small @click="$emit('edit', user)">
          <v-icon x-small left>mdi-pencil</v-icon> EDITAR
        </v-btn>
        <v-btn depressed outlined color="primary" x-small @click="$emit('changePassword', user)">
          <v-icon x-small left>mdi-lock-reset</v-icon>
        </v-btn>
        <v-btn v-if="showDelete" class="ml-2" depressed outlined color="error" x-small @click="$emit('delete', user)">
          <v-icon x-small left>mdi-delete</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { FormatsMixin } from "@/mixins/Formats";

export default {
  name: "UsersTableItem",
  mixins: [FormatsMixin],
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    showDelete: false,
    showEdit: false,
  }),
  mounted() {
    const { rol } = JSON.parse(localStorage.LCInternet).user;
    this.showDelete = rol === "admin";
    this.showEdit = rol === "admin";
  },
  computed: {
    rolColor() {
      return this.user.rol === "admin" ? "primary" : "secondary";
    },
  },
};
</script>

<style lang="scss" scoped>
.info--usuario {
  width: 25%;
}
.info--rol {
  width: 20%;
}
.info--estatus {
  width: 15%;
}
.info--fecha {
  width: 20%;
}
.info--action {
  width: 20%;
}
</style>
